import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';


export default function Headerdash() {
  const [userData, setUserData] = useState({
    username: "",
    firstname: "",
    lastname: "",
  });

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try{
      const response = await fetch('/logout',{
        method: 'GET',
        credentials: 'include', // Includes creditials to send cookie with the session ID
      });
      if(response.status === 200) {
        // PrivateRoutes();
        navigate('/login')
        console.log('Logout Successfully')        
      } else {
         console.error('Logout Failed');
      }
    } catch (error) {
      console.error('Error During Logout:', error)
    }
  }

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch("/api/user-info", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.status === 200) {
          const data = await response.json();
          setUserData({
            username: data.username,
            firstname: data.firstname,
            lastname: data.lastname,
          });
        } else {
          console.error("Failed to fetch User data");
        }
      } catch (error) {
        console.error("Error fetching User data:", error);
      }
    };

    fetchUserData();
  }, []);

  return (
    <header className="fixed z-10 w-full bg-gray-50">
      <div className="mx-auto max-w-screen-6xl px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex items-center sm:justify-between sm:gap-4">
          {/* Mobile Sidebar Toggle Button */}
          <button
            className="sm:hidden text-gray-600"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            ☰
          </button>

          <h1 className="text-md hidden sm:block font-bold text-gray-900 sm:text-3xl md:text-xl">
            Welcome Back, {userData.firstname} {userData.lastname}
          </h1>

          <div className="flex flex-1 items-center justify-between gap-8 sm:justify-end">
            <div className="flex gap-4 justify-center items-center">
              <a
                href="#"
                className="hidden sm:block shrink-0 rounded-lg bg-white p-2.5 text-gray-600 shadow-sm hover:text-gray-700"
              >
                <span className="sr-only">Academy</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M12 14l9-5-9-5-9 5 9 5z" />
                  <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
                </svg>
              </a>

              <a
                href="#"
                className="block shrink-0 rounded-lg bg-white p-2.5 text-gray-600 shadow-sm hover:text-gray-700"
              >
                <span className="sr-only">Notifications</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                  />
                </svg>
              </a>
            </div>

            <button type="button" className="group flex shrink-0 items-center rounded-lg transition">
              <span className="sr-only">Menu</span>
              <img
                alt="User"
                src="https://www.shutterstock.com/image-vector/user-profile-icon-vector-avatar-600nw-2220431045.jpg"
                className="h-10 w-10 rounded-full object-cover"
              />

              <p className="ms-2 hidden text-left text-xs sm:block">
                <strong className="block font-medium">
                  {userData.firstname} {userData.lastname}
                </strong>
                <span className="text-gray-500"> {userData.username} </span>
              </p>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Sidebar */}
      {isSidebarOpen && (
        <div className="fixed inset-0 z-20 bg-gray-800 bg-opacity-75">
          <div className="fixed left-0 top-0 h-full w-64 bg-white p-5">
            <button
              className="mb-4 text-gray-600"
              onClick={() => setIsSidebarOpen(false)}
            >
              ✕
            </button>
            <nav>
              <a href="/dashboard" className="block p-2 text-gray-900 hover:bg-gray-100">Dashboard</a>
              <a href="/practice" className="block p-2 text-gray-900 hover:bg-gray-100">Practice</a>
              <a href="/mockpage" className="block p-2 text-gray-900 hover:bg-gray-100">Mock Test </a>
              <a href="/billing" className="block p-2 text-gray-900 hover:bg-gray-100">Billing </a>
            </nav>
            <div className="absolute inset-x-0 bottom-0 border-t border-gray-100 bg-white p-2">
        <form>
          <button
            onClick={handleLogout}
            type="button"
            className="group relative flex items-center justify-center w-full rounded-lg px-2 py-1.5 text-sm text-gray-500 hover:bg-gray-50 hover:text-gray-700"
          >
            <p className="text-sm pr-2">
              <strong className="block font-medium">Logout</strong>
            </p>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 opacity-75"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
              />
            </svg>
          </button>
        </form>
      </div>
          </div>
        </div>
      )}
    </header>
  );
}
